import Mason from './Mason';
import HorizontalCardIconFactory from '../shared/HorizontalCardIconFactory';
import MicroIcon from '../shared/MicroIcon';
import MasonCard from './MasonCard';
import Icon from 'components/Icon';

const Micro = MicroIcon(Icon.OPTIONS.SELECT_CHART);

export const card = MasonCard;
export const details = Mason;
export const micro = Micro;
export const icon = Micro;
export const horizontal = HorizontalCardIconFactory(Micro);
export const preview = MasonCard;
